import axios from 'axios';

import formatError from '../utils/format-error';
import {
  retryInvalidCsrf,
  type CsrfRetryRequestConfig,
  attachCsrfRequestInterceptor,
} from '../utils/csrf-interceptors';

const ADMIN_LOGIN_PATH = '/admin/login';
const ADMIN_USER_INFO_ENDPOINT = '/admin/user-info';

// Separate instance from the main app axios: a 401 here sends the admin to
// /admin/login, never to SSO. CSRF handling mirrors the main instance.
const adminAxiosInstance = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

attachCsrfRequestInterceptor(adminAxiosInstance);

adminAxiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config as CsrfRetryRequestConfig;
    if (!originalRequest._retryCount) {
      originalRequest._retryCount = 0;
    }
    const err = formatError(error);

    const onLoginPage =
      typeof window !== 'undefined' && window.location.pathname === ADMIN_LOGIN_PATH;
    const isAdminInfoBootstrap = originalRequest?.url?.includes(ADMIN_USER_INFO_ENDPOINT);

    if (error.response?.status === 401 && !onLoginPage && !isAdminInfoBootstrap) {
      window.location.assign(ADMIN_LOGIN_PATH);
      return Promise.reject(error);
    }

    try {
      const csrfRetryResponse = await retryInvalidCsrf(err, originalRequest, adminAxiosInstance);
      if (csrfRetryResponse) return csrfRetryResponse;
    } catch (refreshCsrfError) {
      return Promise.reject(refreshCsrfError);
    }

    return Promise.reject(error);
  }
);

export default adminAxiosInstance;
